(function () {
  function prep(v) {
    // data-sm-sound="<volume>": plays with audio, this script never mutes it
    if (v.dataset.smSound) { v.playsInline = true; return; }
    // don't re-mute a video the user deliberately unmuted (hero has controls + audio)
    if (v.dataset.smUserUnmuted !== 'true') {
      v.muted = true;
      v.setAttribute('muted', '');
    }
    v.playsInline = true;
  }

  // lazy-src: sections render heavy autoplay videos with data-src instead of src
  // (autoplay defeats preload="none" and downloads the file at page load);
  // hydrate() moves data-src into src the first time the video nears the viewport
  function hydrate(v) {
    if (!v.dataset.src || v.getAttribute('src')) return;
    v.src = v.dataset.src;
    delete v.dataset.src;
    try { v.load(); } catch (e) {}
  }

  // geometry guard: before images/CSS finish, sections are collapsed and every
  // video measures "near the top", so IO alone would hydrate all of them at once
  // (seen as 2.8MB of mp4 in the PSI trace); always re-check the live rect
  function isNear(v) {
    var r = v.getBoundingClientRect();
    return r.top < window.innerHeight + 600 && r.bottom > -600;
  }

  function hydrateIfNear(v) {
    if (v.dataset.src && isNear(v)) hydrate(v);
  }

  function tryPlay(v) {
    if (v.dataset.smUserPaused === 'true') return;
    if (!v.paused) return;
    if (!v.getAttribute('src')) {
      hydrateIfNear(v);
      if (!v.getAttribute('src')) return;
    }
    prep(v);
    var p;
    try { p = v.play(); } catch (e) { return; }
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function init() {
    var videos = Array.prototype.slice.call(document.querySelectorAll('video[autoplay], video[data-sm-sound]'));
    if (!videos.length) return;

    videos.forEach(function (v) {
      prep(v);
      // volume is read-only on iOS Safari; no-op there
      if (v.dataset.smSound) {
        var vol = parseFloat(v.dataset.smSound);
        if (vol >= 0 && vol <= 1) { try { v.volume = vol; } catch (e) {} }
      }

      v.addEventListener('loadeddata', function () {
        if (v.dataset.smInView !== 'false') tryPlay(v);
      });

      v.addEventListener('pause', function () {
        if (v.dataset.smAutoPaused === 'true') { v.dataset.smAutoPaused = ''; return; }
        if (v.ended) return;
        // only a pause on a controls-enabled, visible video counts as user intent;
        // anything else (tab hide, other scripts) must not block future retries
        if (v.controls && document.visibilityState === 'visible') {
          v.dataset.smUserPaused = 'true';
        }
      });

      v.addEventListener('play', function () {
        v.dataset.smUserPaused = '';
      });

      v.addEventListener('volumechange', function () {
        if (v.controls && document.visibilityState === 'visible') {
          v.dataset.smUserUnmuted = v.muted ? '' : 'true';
        }
      });
    });

    // observers start only after window load: earlier the layout is still
    // collapsing/expanding while CSS+images stream in, and IO callbacks fire
    // with geometry that puts every video "in view"
    function startObserving() {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target;
            if (entry.isIntersecting) {
              v.dataset.smInView = 'true';
              if (v.preload === 'none' && v.getAttribute('src') && v.readyState === 0) { try { v.load(); } catch (e) {} }
              tryPlay(v);
            } else {
              v.dataset.smInView = 'false';
              if (!v.paused) {
                v.dataset.smAutoPaused = 'true';
                v.pause();
              }
            }
          });
        }, { threshold: 0.25 });
        videos.forEach(function (v) { io.observe(v); });

        // start the download a bit before the play-observer fires so the video
        // is ready (or nearly) by the time it becomes 25% visible
        var preIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && isNear(entry.target)) {
              hydrate(entry.target);
              preIo.unobserve(entry.target);
            }
          });
        }, { rootMargin: '600px 0px' });
        videos.forEach(function (v) { if (v.dataset.src) preIo.observe(v); });
      } else {
        videos.forEach(function (v) { hydrate(v); tryPlay(v); });
      }
    }

    if (document.readyState === 'complete') {
      startObserving();
    } else {
      window.addEventListener('load', startObserving);
    }

    function retryVisible() {
      videos.forEach(function (v) {
        if (v.dataset.smInView !== 'false') tryPlay(v);
      });
    }

    ['touchstart', 'click', 'keydown', 'scroll'].forEach(function (evt) {
      document.addEventListener(evt, retryVisible, { passive: true });
    });

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) retryVisible();
    });

    window.addEventListener('pageshow', function (e) {
      if (e.persisted) retryVisible();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
